<template>
  <div>
    <!-- 风险告知书 融资者 -->
    <div v-if="type == 1">
      <h2>风险告知书</h2>
      <p>尊敬的用户：</p>
      <p class="sj">
        在您进行融资之前，请谨慎阅读本《风险告知书》，仔细了解域名融资可能面临的风险，并谨慎进行判断和决定是否进行融资，若您点击并确认本《风险告知书》意味着您已经知悉了融资所面临的风险，并做好了承受风险的准备。您在融资中所面临的风险包括但不限于以下几个方面：
      </p>
      <p>
        一、法律、政策风险，因本网站面向全球客户，本网站业务在您所在国家或地区可能会存在合规风险，届时可能对您的融资造成不利后果。
      </p>
      <p>
        二、域名价值波动风险，因域名行情是处于波动的状态，因此域名的价值可能降低，届时将可能导致域名价值低于融资金额的风险。
      </p>
      <p>
        三、域名特有风险，由于域名的特殊性，用于担保的域名可能会存在权属纠纷、使用权瑕疵等导致域名被转移或者价值降低的风险。
      </p>
      <p>
        四、操作风险，您在业务操作过程中发生差错，或者委托他人付款可能会存在延迟或者损失的风险。
      </p>
      <p>
        五、处置风险，若您违约，您的域名将会被投资人自行或者委托第三方通过拍卖，议价，一口价，打包价等方式进行处置，届时您的域名可能面临低价处置的风险，若域名处置款不足以清偿债务，您仍然需要补足。
      </p>
      <p>
        六、无担保风险，融资界及HONGKONG PROFIT POWER
        LIMITED不会对融资人的融资做任何形式的保证、担保，也不会对融资款进行兑付，届时您可能面临域名被处置的风险。
      </p>
      <p>
        七、其他风险，即由于其他不可预见或者很难遇见的情形将会给融资带来损失的风险。
      </p>
      <p class="text-right">HONGKONG PROFIT POWER LIMITED</p>
    </div>
    <!-- 风险告知书 投资者 -->
    <div v-if="type == 2">
      <h2>风险告知书</h2>
      <p>尊敬的投资人：</p>
      <p class="sj">
        在您进行投资之前，请谨慎阅读本《风险告知书》，仔细了解域名投资可能面临的风险，并谨慎进行判断和决定是否进行投资，若您点击并确认本《风险告知书》意味着您已经知悉了投资所面临的风险，并做好了承受风险的准备。您在投资中所面临的风险包括但不限于以下几个方面：
      </p>
      <p>
        一、法律、政策风险，因本网站面向全球客户，本网站业务在您所在国家或地区可能会存在合规风险，届时可能对您的投资造成不利后果。
      </p>
      <p>
        二、域名价值波动风险，因域名行情是处于波动的状态，因此域名的价值可能降低，届时将可能导致域名价值低于融资金额的风险。
      </p>
      <p>
        三、域名特有风险，由于域名的特殊性，用于担保的域名可能会存在权属纠纷、使用权瑕疵等导致域名被转移或者价值降低的风险。
      </p>
      <p>
        四、操作风险，您在业务操作过程中发生差错，或者委托他人付款可能会存在延迟或者损失的风险。
      </p>
      <p>
        五、信用风险，您投资的对象可能会因为各种原因发生违约，将有可能导致您收不回投资款的风险。
      </p>
      <p>
        六、无担保风险，融资界及HONGKONG PROFIT POWER
        LIMITED不会对投资人的投资做任何形式的保证、担保，也不会对投资款进行兑付，届时可能面临投资款损失风险。若发生违约，域名一律通过拍卖、议价、一口价、打包价等方式进行处置，处置资金不足以支付投资款的，则投资人将发生实质损失。
      </p>
      <p>
        七、其他风险，即由于其他不可预见或者很难遇见的情形将会给投资带来损失的风险。
      </p>
      <p class="text-right">HONGKONG PROFIT POWER LIMITED</p>
    </div>
    <!-- 域名投资协议 -->
    <div v-if="type == 3">
      <h2>声明</h2>
      <p>尊敬的用户：</p>
      <p>
        域名投资系注册用户之间的行为，与融资界及其运营公司HONGKONG PROFIT POWER
        LIMITED无关，交易过程由注册用户自行完成。对于域名投资款及域名，融资界及其运营公司HONGKONG
        PROFIT POWER LIMITED没有任何偿还义务，也不承担保证责任和兑付责任。
      </p>
      <p class="text-right">HONGKONG PROFIT POWER LIMITED</p>

      <h2>域名投资协议</h2>

      <p>甲方（域名持有人）：</p>
      <div
        v-if="
          agreeData &&
            agreeData.State != 0 &&
            agreeData.State != 3 &&
            agreeData.State != 4 &&
            agreeData.State != 5
        "
      >
        <table>
          <tr>
            <td :style="{ width: '20%' }">用户ID</td>
            <td>{{ personMsg.LoanUser.UserId }}</td>
            <td>真实姓名</td>
            <td>{{ personMsg.LoanUser.RealName }}</td>
          </tr>
          <tr>
            <td :style="{ width: '20%' }">身份证号码</td>
            <td>{{ personMsg.LoanUser.IdCardNumber }}</td>
            <td>注册邮箱</td>
            <td>{{ personMsg.LoanUser.Email }}</td>
          </tr>
        </table>

        <table :style="{ borderTop: 0 }" width="20%">
          <tr>
            <td :style="{ width: '20%' }">质押域名</td>
            <td class="domain">
              <span v-for="(v, i) in personMsg.LoanPledgeList" :key="i"
                >{{ v.PledgeName }} ，</span
              >
            </td>
          </tr>
        </table>

        <p>乙方（投资人）：</p>
        <table>
          <tr>
            <td>真实姓名</td>
            <td>用户ID</td>
            <td>投资金额(元)</td>
            <td>投资周期(天)</td>
          </tr>
          <tr v-for="(v, i) in personMsg.InvestmentSchemeList" :key="i">
            <td>{{ v.RealName }}</td>
            <td>{{ v.UserId }}</td>
            <td>{{ v.Amount }}</td>
            <td>{{ v.InvestCycleValue }}</td>
          </tr>
        </table>

        <p>
          甲方、乙方均系融资界知识产权服务平台（以下简称融资界）注册用户，甲、乙双方均
          对域名有比较专业的认识，现就域名投资相关事宜达成如下协议。
        </p>
        <p>
          <b>一、借款基本信息</b>
        </p>
        <p>
          1.1甲方作为域名的持有人，将托管域名质押乙方，向乙方进行借款，乙方同意对甲方进行投资。
        </p>
        <table>
          <tr>
            <td>项目编号</td>
            <td>{{ agreeData.Number }}</td>
          </tr>
          <tr>
            <td>借款详细用途</td>
            <td>{{ agreeData.Description }}</td>
          </tr>
          <tr>
            <td>借款本金数额（小写）</td>
            <td>¥{{ agreeData.Amount }}</td>
          </tr>
          <tr>
            <td>借款本金数额（大写）</td>
            <td>{{ agreeData.Amount | upmoney }}</td>
          </tr>
          <tr>
            <td>借款年化利率</td>
            <td>{{ $math.eval(`${agreeData.Rate}*100`) }}%</td>
          </tr>
          <!-- <tr>
            <td>管理费率（由域名托管人收取）</td>
            <td>{{$math.eval(`${agreeData.ManagementFeeRate}*100`)}}%</td>
          </tr>-->
          <tr>
            <td>域名管理费率（域名持有人支付）</td>
            <td>{{ $math.eval(`${agreeData.ManagementFeeRate}*100`) }}%/月</td>
          </tr>
          <tr>
            <td>投资管理费率（投资人支付）</td>
            <td>{{ $math.eval(`${safe.InvestManagementFeeRate}*100`) }}%/月</td>
          </tr>
          <tr>
            <td>月还款额</td>
            <td>详情见还款计划 （固定）</td>
          </tr>
          <tr>
            <td>还款日</td>
            <td>详情见还款计划 （固定）</td>
          </tr>
          <tr>
            <td>借款到期日</td>
            <td>{{ agreeData.EndAt }}</td>
          </tr>
          <tr>
            <td>协议生效日期</td>
            <td>{{ agreeData.ProtocolAt }}</td>
          </tr>
        </table>

        <p>还款计划：</p>
        <table>
          <tr>
            <td>期数</td>
            <td>还款日期</td>
            <td>还款金额</td>
            <td>还款类型</td>
          </tr>
          <tr v-for="(v, i) in personMsg.RepaymentPlanList" :key="i">
            <td>{{ v.Phase }}</td>
            <td>{{ v.RepayAt }}</td>
            <td>¥{{ v.RepayAmount }}</td>
            <td>{{ v.IsEndPhase == true ? "本金+利息" : "利息" }}</td>
          </tr>
        </table>
      </div>
      <div v-else>
        <table>
          <tr>
            <td>用户ID</td>
            <td>（&ID）</td>
            <td>真实姓名</td>
            <td>（&真实姓名）</td>
          </tr>
          <tr>
            <td>身份证号码</td>
            <td>（&甲方身份证号）</td>
            <td>注册邮箱</td>
            <td>（&注册邮箱）</td>
          </tr>
          <tr>
            <td>质押域名</td>
            <td colspan="3">（&抵押的域名，以分号隔开）</td>
          </tr>
        </table>

        <p>乙方（投资人）：</p>
        <table>
          <tr>
            <td>真实姓名</td>
            <td>用户ID</td>
            <td>投资金额</td>
            <td>投资周期</td>
          </tr>
          <tr>
            <td>（&真实姓名）</td>
            <td>（&ID）</td>
            <td>（&投标金额）</td>
            <td>（&投标周期）</td>
          </tr>
        </table>

        <p>
          甲方、乙方均系融资界知识产权服务平台（以下简称融资界）注册用户，甲、乙双方均
          对域名有比较专业的认识，现就域名投资相关事宜达成如下协议。
        </p>
        <p>
          <b>一、借款基本信息</b>
        </p>
        <p>
          1.1甲方作为域名的持有人，将托管域名质押乙方，向乙方进行借款，乙方同意对甲方进行投资。
        </p>
        <table>
          <tr>
            <td>项目编号</td>
            <td>（&借款项目编号）</td>
          </tr>
          <tr>
            <td>借款详细用途</td>
            <td>个人消费（&借款用途）</td>
          </tr>
          <tr>
            <td>借款本金数额（小写）</td>
            <td>（&融资金额）</td>
          </tr>
          <tr>
            <td>借款本金数额（大写）</td>
            <td>（&融资金额大写）</td>
          </tr>
          <tr>
            <td>借款年化利率</td>
            <td>（&年化）</td>
          </tr>
          <!-- <tr>
            <td>管理费率（由域名托管人收取）</td>
            <td>（&年化）</td>
          </tr>-->
          <tr>
            <td>域名管理费率（域名持有人支付）</td>
            <td>（&年化）</td>
          </tr>
          <tr>
            <td>投资管理费率（投资人支付）</td>
            <td>（&年化）</td>
          </tr>
          <tr>
            <td>月还款额</td>
            <td>详情见还款计划 （固定）</td>
          </tr>
          <tr>
            <td>还款日</td>
            <td>详情见还款计划 （固定）</td>
          </tr>
          <tr>
            <td>借款到期日</td>
            <td>（&借款到期日）</td>
          </tr>
          <tr>
            <td>协议生效日期</td>
            <td>（&放款时间）</td>
          </tr>
        </table>

        <p>还款计划：</p>
        <table>
          <tr>
            <td>期数</td>
            <td>还款日期</td>
            <td>还款金额</td>
            <td>还款类型</td>
          </tr>
          <tr>
            <td>1</td>
            <td>（&还款日期）</td>
            <td>（&还款金额）</td>
            <td>（&利息）</td>
          </tr>
          <tr>
            <td>2</td>
            <td>（&还款日期）</td>
            <td>（&还款金额）</td>
            <td>（&利息+本金）</td>
          </tr>
        </table>
      </div>
      <p>
        <b>二、协议的订立、生效</b>
      </p>
      <p>
        2.1甲、乙双方通过网络点击的方式在线订立《域名投资协议》，投资人点击确认《域名投资协议》后，合同成立，乙方在平台释放投资款后，合同生效。
      </p>
      <p>
        2.2《域名投资协议》在甲方及乙方之间发生法律效力，合同生效后，融资界其他注册用户可以通过直接代甲方偿还乙方投资款的方式取得乙方投资人资格，届时原乙方投资人退出协议，新乙方投资人加入，《域名投资协议》在甲方及新乙方投资人之间继续生效。
      </p>
      <p>
        <b>三、域名托管</b>
      </p>
      <p>
        3.1乙方指定第三方域名服务商（简称域名托管人）代乙方接收甲方质押的域名，域名托管人为甲、乙双方提供收取、保管、转移、处置域名服务（以下简称域名托管服务）。
      </p>
      <p>
        3.2甲、乙双方授权并确定由融资界负责通知域名托管人提供收取、保管、转移、处置域名服务。
      </p>
      <p>
        3.3本协议生效后，甲方应当按时向域名托管人支付域名管理费。甲方可以向域名托管人预存域名管理费，域名托管人优先扣除预存的域名管理费。若甲方未按时结清借款或域名管理费，甲方无权要求域名托管人返还质押域名。域名托管期间由甲方负责续费。
      </p>
      <p>
        <b>四、承诺及保证</b>
      </p>
      <p>
        4.1甲、乙双方承诺融资界及域名托管人对借款不承担任何风险，也不需要对借款承担保证责任、兑付责任，甲、乙双方域名投资权利义务与融资界无关。融资界网页上所有的数据均为注册用户发布，仅供甲、乙双方进行参考，风险由甲、乙双方自行承担。
      </p>
      <p>
        4.2甲、乙双方承诺，对本协议涉及的所有款项包括本金、利息、管理费等项目的数额由各方自行核算，若发生纠纷的，以融资界记录到的数据为准。
      </p>
      <p>4.3甲方承诺按还款计划偿还投资款本金利息及域名管理费。</p>
      <p>
        4.4甲方承诺其是质押域名的所有权人，对质押域名有完全的处置权利，质押域名不存在任何被盗、赃物、权属、担保、使用权纠纷或其他任何影响域名价值金和权利的情形，也不侵犯他人合法权益。域名托管期间若因域名本身发生纠纷，由甲方承担全部责任。
      </p>
      <p>
        4.5甲方承诺按约定用途使用资金，不得使用用户投资款从事任何违法犯罪活动。
      </p>
      <p>
        4.6乙方确认资金来源合法，并为其合法所有，乙方不存赌博、洗钱、掩饰隐瞒犯罪所得、赃款等违法犯罪情形，也不得吸收他人的资金用于投资。
      </p>
      <p>
        <b>五、付款及还款</b>
      </p>
      <p>5.1乙方指定账户向甲方付款，甲方应当使用自己名下的银行账户用于收款。</p>
      <p>
        5.2还款时甲方应当向乙方指定银行账户偿还款项，因指定收款账户发生争议的责任由乙方自行承担。域名管理费由甲方直接向域名托管人支付，甲方预付费的，由域名托管人自行扣除。乙方应在收到还款之后支付投资管理费。
      </p>
      <p>
        5.3甲方应当按照还款计划还款，还款日不受节假日的影响，还款当日24:00时之前必须还款。
      </p>
      <p>
        <b>六、逾期还款</b>
      </p>
      <p>
        6.1若甲方逾期还款，除按还款计划支付本金及利息外，还应当额外每日按照本息的万分之六的标准向乙方支付罚金。
      </p>
      <p>
        6.2若甲方逾期还款，融资界有权通知域名托管人处置域名，域名托管人可以自行或者委托第三方通过议价、一口价、打包价、拍卖方式或其他方式处置域名，域名处置所产生的手续费及其他费用由甲方承担，优先在处置域名所得款项中扣除。
      </p>
      <p>
        6.3甲、乙双方知悉域名属于知识产权、无形资产，并了解域名的特殊性，明白处置域名存在的各种风险，因此甲、乙双方认可域名托管人通过议价、一口价、打包价、拍卖方式或其他方式处置域名过程之中的一切行为并认可处置域名的结果，尤其可能出现处置域名所得的资金不足以偿还全部借款借款的情形，甲、乙双方仍然认可并承诺不会因为域名处置而追究融资界、域名托管人的任何责任。
      </p>
      <p>
        <b>七、域名处置资金</b>
      </p>
      <p>7.1质押域名处置完后，在质押域名仅用于担保本协议借款情况下：</p>
      <p>
        7.1.1若处置域名所得款项偿还借款后还有剩余资金，则域名托管人应将剩余资金返还给甲方；
      </p>
      <p>
        7.1.2若处置域名所得款项不足以清偿本协议借款，则甲方应当继续承担清偿责任，直至借款还清为止。
      </p>
      <p>7.2质押域名处置完后，在质押域名在融资界用于担保多笔借款情况下：</p>
      <p>
        7.2.1若处置域名所得款项可以偿还全部借款后还有剩余资金，则域名托管人应将剩余资金返还给甲方；
      </p>
      <p>
        7.2.2若处置域名所得款项不能偿还完所有借款，则处置域名所得款项应当按照每笔借款使用的授信比例清偿。未足额得到清偿部分借款，甲方应当继续承担还款责任，直至全部借款还清为止。
      </p>
      <p>
        7.3质押域名处置完后，若处置域名所得款项偿还已到期的借款之后还有剩余资金，但甲方在融资界还有其他未到期的借款需要偿还，则甲方同意将剩余资金作为质押托管在域名托管人用于担保未到期的借款的偿还。
      </p>
      <p>
        7.4若处置域名所得款项不能偿还完借款，但甲方在融资界还有其他域名及款项的，则可以直接处置甲方的其他域名以及款项用于还款。
      </p>
      <p>
        <b>八、通知与送达</b>
      </p>
      <p>
        8.1协议各方因履行本协议而相互发出或者提供的所有通知、文件、资料，均以本协议所列明及在融资界留下的联系地址、电话、邮箱、微信、QQ等联系方式进行送达，可由采用专人送达、挂号邮递、特快专递或通过融资界发布等方式传送，一方如果变更联系方式，应当书面通知融资界，电子信息或者邮件一经发出即视为送达。
      </p>
      <p>
        <b>九、管辖及法律适用</b>
      </p>
      <p>
        9.1本协议的成立、生效、履行、解释及纠纷解决，适用仲裁机构所在地区法律。
      </p>
      <p>
        9.2若用户和融资界之间发生任何纠纷或争议无法自行解决的，应向深圳仲裁委员会申请仲裁，仲裁流程及规则以申请时的流程及规则为准。
      </p>
    </div>
    <!-- 用户服务协议 -->
    <div v-if="type == 4">
      <h2>阅读提示</h2>
      <p>尊敬的用户：</p>
      <p>
        融资界知识产权服务平台（以下简称融资界）系由HONGKONG PROFIT POWER
        LIMITED建立并运营，旨在打造全球化的知识产权服务机构，并为融资界的注册用户提供完善的知识产权服务。请您在注册用户时，谨慎阅读《用户服务协议》，当您通过在线点击的方式确认并同意《用户服务协议》，一旦点击确认即代表您接受协议的全部条款。
      </p>
      <p>
        融资界特别提示您注意《用户服务协议》中有关风险、免责、权利限制、纠纷管辖条款，若您不接受这些条款，请您不要注册成为融资界的用户。
      </p>
      <p class="text-right">HONGKONG PROFIT POWER LIMITED</p>
      <h2>用户服务协议</h2>
      <h3>第一部分 协议的订立、生效、修改</h3>
      <p>
        1.1《用户服务协议》通过网络点击确认的方式在线订立，用户在注册时通过点击按钮确认并同意《用户服务协议》后生效。
      </p>
      <p>
        1.2《用户服务协议》在用户及HONGKONG PROFIT POWER
        LIMITED之间发生法律效力。
      </p>
      <p>
        1.3若用户未点击《用户服务协议》，但实际上使用了融资界提供的相应功能或服务时，本协议仍然生效。
      </p>
      <p>
        1.4用户使用融资界相应服务除了应当遵守《用户服务协议》，还应当遵守融资界为相应服务而专门发布的协议、规定等规则。用户未经注册但是用了融资界的相关服务功能的，除了应当遵守相应服务而专门发布的协议、规定等规则，也应当遵守《用户服务协议》。
      </p>
      <p>
        1.5融资界有权修改《用户服务协议》，更新后的协议一经发布即发生即生效，用户有义务在使用融资界时查询最新的《用户服务协议》，并承诺遵守修改后的《用户服务协议》。
      </p>
      <h3>第二部分 用户的权利及义务</h3>
      <p>
        2.1用户可以是自然人、法人或其他组织，用户应当具有完全的民事权利能力和行为能力（公民的民事权利能力及行为能力以其所在国或地区为准），禁止无完全民事权利能力和行为能力的用户注册并使用融资界的任何服务。
      </p>
      <p>
        2.2用户应当按照融资界的要求填写真实的姓名、身份证件号码、联系地址、联系方式等信息，具体以融资界注册页面要求为准。用户应当妥善保管用户名、密码、密保、邮箱等与安全相关的信息，防止该信息被他人盗取。用户使用用户名登陆后的所有操作，全部视为用户本人的操作，由用户承担全部责任。
      </p>
      <p>
        2.3用户注册成功后可以在融资界浏览或发布与域名、著作权、商标权、专利权等知识产权相关的信息，如知识产权的权利归属、价值大小、简介、权利来源、持有人信息、转让价格、交易方式等信息，注册用户承诺所发布的信息是真是有效的，且不遗漏应当告知其他用户的情形。融资界服务及功能仅提供给注册用户使用，用户注册成功后才可以使用，用户可以使用的服务及功能以融资界实际公布为准。
      </p>
      <p>
        2.4禁止用户发布虚假信息或侵犯他人的合法权益的信息，未经知识产权权利人的许可不得发布不属于用户的知识产权的信息。
      </p>
      <p>
        2.5若用户使用融资界的服务及功能涉及资金的，提供资金的用户应当承诺资金来源是正当的、合法的，不是违法犯罪所得，也不涉及洗钱和吸收他人存款的情形，收取资金的用户应当承诺正当的、合法的使用该资金。注册用户之间从事知识产权交易的，可以通过自行或委托他人的方式进行交易。涉及资金的划转、知识产权的交付的，由用户自行完成或者委托其他第三方服务机构完成，融资界不参与注册用户的融资活动。用户可以指定银行账户用于交易双方之间的资金划转，指定账户应当符合所在国家或地区的法律或政策。
      </p>
      <p>
        2.6用户发布或使用融资界的相关功能应当符合所在国家或地区的法律规定，不得从事用户所在国家或地区禁止开展的服务。
      </p>
      <h3>第三部分 融资界的权利及义务</h3>
      <p>
        3.1融资界以使用服务当时的状态为用户提供知识产权服务，允许注册用户在融资界发布相应的知识产权信息，并从事与知识产权相关的业务。融资界在现有技术上对网站各个模块及功能板块进行维护，并努力改进相关技术，完善在线注册或信息发布等功能，但融资界不承诺一定能够满足或实现用户所需要的功能。
      </p>
      <p>
        3.2若融资界发现用户发布的信息或开展的业务存在异常，融资界有权不通知用户即暂停或中止用户的相关操作，并有权采取一切措施，包括但不限于限制用户功能，撤销用户操作，交易回滚等，直至异常情形消除，恢复至正常状态。用户的操作是否属于异常，由融资界认定，因业务异常导致的损失，由用户自行承担。
      </p>
      <p>
        3.3若注册用户之间发生纠纷，注册用户可以申请融资界进行处理，融资界同意为双方处理纠纷的，可以自行或者委托第三方进行调查处理，由此产生费用的，全部由注册用户承担，涉及第三方机构的收费服务项目的，注册用户应当直接向第三方机构支付。注册用户之间发生对资金项目发生争议的，以融资界记录到的数据为准。
      </p>
      <p>
        3.4融资界不对注册用户之间的任何交易承担任何责任，不会为用户的资金提供担保，一切注册用户间的交易由注册用户自行承担责任，融资界不承诺的事项包括但不限于以下情形：
        <br />（1）融资界不承诺用户之间的交易一定能够完成或交易目的一定能够实现；
        <br />（2）融资界不承诺用户出借的资金一定能够收回；
        <br />（3）不承诺用户或第三方机构交易或处置知识产权不会造成损失；
        <br />（4）不承诺交易知识产权的权属是完整的或没有使用限制；
        <br />（5）其他与融资界无关的事项。
      </p>
      <h3>第四部分 风险提示</h3>
      <p>
        4.1用户确认：融资界上的信息均为融资界注册用户发布的信息，融资界对注册用户发布的信息的真实性不承担责任，信息的真实性由注册用户自行分辨。
      </p>
      <p>
        4.2用户确认：融资界上的知识产权交易均由融资界注册用户发起，注册用户拟交易的知识产权可能会存在瑕疵，如权属瑕疵，担保瑕疵或使用瑕疵等。
      </p>
      <p>
        4.3用户确认：若用户以知识产权作为质押发起借款交易，则存在还款不能时，知识产权被低价处置的风险，以及出借的资金可能会发生损失的风险。
      </p>
      <p>
        4.4用户确认：若用户所在国家或地区禁止用户从事知识产权交易，则用户之间的交易存在被认定为无效的可能。
      </p>
      <p>
        4.5用户确认：因用户之间的交易涉及不同国家法律政策的，则在不同的国家法律政策不尽相同，用户可能会面临所在国家或地区的法律政策风险。
      </p>
      <h4>第五部分 服务费用</h4>
      <p>
        5.1用户在融资界浏览、发布知识产权信息，使用融资界提供的功能，融资界不收取费用。
      </p>
      <p>
        5.2用户之间自行发起并完成知识产权交易的，用户不需要支付费用。若用户选取第三方机构提供知识产权价值评估、知识产权托管、委托办理知识产权过户手续、委托出售知识产权、知识产权拍卖、知识产权经纪交易等服务的，由提供服务的第三方机构收取相关费用。
      </p>
      <p>
        5.3第三方服务机构的收费标准，由第三方服务机构决定，用户选择第三方服务机构的，应当直接向第三方服务机构支付相关费用。收费标准发生变更的，以发生交易时的收费标准为准。
      </p>
      <h3>第六部分 不可抗力及免责</h3>
      <p>
        6.1因无法预见或不能克服的法律、技术以及其他风险，包括但不限于因不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因导致的服务中断、数据丢失或其他损失的，融资界不承担责任。
      </p>
      <p>
        6.2即使融资界提供的服务存在瑕疵，但瑕疵是当时技术水平所无法避免的，由此给用户造成的数据或信息丢失等损失的，融资界不承担任何责任。
      </p>
      <h3>第七部分 融资界知识产权声明</h3>
      <p>
        7.1
        融资界提供的内容（包括但不限于网页、文字、图片、音频、视频、图表等）及融资界提供服务时所依托的域名、网站、软件的著作权、商标权、专利权及其他知识产权均归PROFIT
        POWER LIMITED所有。
      </p>
      <h3>第八部分 通知与送达</h3>
      <p>
        8.1协议各方因履行本协议而相互发出或者提供的所有通知、文件、资料，均以本协议所列明及在融资界留下的联系地址、电话、邮箱、微信、QQ等联系方式进行送达，可由采用专人送达、挂号邮递、特快专递或通过融资界发布等方式传送，一方如果变更联系方式，应当书面通知融资界，电子信息或者邮件一经发出即视为送达。
      </p>
      <h3>第九部分 管辖及法律适用</h3>
      <p>9.1本协议的成立、生效、履行、解释及纠纷解决，适用香港地区法律。</p>
      <p>
        9.2若用户和融资界之间发生任何纠纷或争议无法自行解决的，应向Hong Kong
        International Arbitration
        Centre（HKIAC）申请仲裁，仲裁流程及规则以申请时的流程及规则为准。
      </p>
    </div>
    <!-- 隐私保护协议 -->
    <div v-if="type == 5">
      <h2>隐私保护规则</h2>
      <p>
        第一条
        为更好的保护用户的隐私，保护用户的知识产权信息，以及更好的为客户提供服务，制定本规则。
      </p>
      <p>
        第二条
        本规则适用于融资界所有服务，但不适用于其他第三方向用户提供的服务。
      </p>
      <p>
        第三条
        融资界应当以具体的、清晰的和正当的目的，以及合法、合理、透明的方式处理用户信息数据。
      </p>
      <p>
        第四条
        用户数据应当保持准确性，对不准确的信息，用户有权更正和擦除，处理用户数据应当在必要的限度之内。
      </p>
      <p>
        第五条
        融资界有权要求自然人用户提供姓名、性别、身份证号码、身份证复印件、护照、联系电话、邮箱，地址、银行账号、开户行、账户名等与用户身份信息、联系信息、财务信息相关的信息。
      </p>
      <p>
        第六条
        融资界有权要求法人或其他组织提供单位名称、注册地址、营业执照、法定代表人身份证明、注册地址、联系电话、邮箱、银行账号、开户行、账户名等与法人或其他组织注册信息、联系信息、财务信息相关的信息。
      </p>
      <p>
        第七条
        若因融资界业务模式的变更，需要用户合理的提供其他信息的，由融资界将需要提供的信息公示在融资界网站上，供用户填写，新增的用户信息，将按照本规则被平等的处理和保护。
      </p>
      <p>
        第八条 用户在使用服务的同时，融资界会收集以下信息：
        <br />（1）设备信息：如设备型号、操作系统版本、设备设置、唯一设备标识符等软硬件特征信息）、设备所在位置相关信息（例如IP地址、GPS位置以及能够提供相关信息的Wi-Fi接入点、蓝牙和基站等传感器信息）。
        <br />（2）日志信息：当用户使用网站提供的服务时，融资界会自动收集用户对融资界服务的详细使用情况，作为有关网络日志保存。例如用户的搜索查询内容、IP地址、浏览器的类型、电信运营商、使用的语言、访问日期和时间及用户访问的网页记录等。
        <br />（3）用户账户的支持信息：基于用户使用融资界服务而产生的用户的咨询记录、报障记录和针对用户故障的排障过程（如通信或通话记录），融资界将通过记录、分析这些信息以便更及时响应用户的帮助请求，以及用于改进服务。
        <br />（4）历史服务信息：例如用户曾使用过的服务的类型、浏览过的内容、使用过的功能、历史的交易数据、历史信用信息数据、历史交易数据、历史授权数据、知识产权权属信息、历史变动信息等。
      </p>
      <p>
        第八条 融资界可能出于如下目的，使用用户提交或融资界收集的用户信息：
        <br />（1）为了向用户提供，维护、改进服务；
        <br />（2）有权部门或利害关系人要求提供信息；
        <br />（3）按照知识产权相关主管部门的要求提供信息；
        <br />（4）其他合理目的。
      </p>
      <p>
        第九条
        融资界不会跟第三方机构以共享、转让、授权、公开披露等方式使用用户数据，除非用户本人许可或应有关部门的要求或有合理的理由以该等方式使用用户数据。
      </p>
      <p>
        第十条
        用户可以登录网站后台查询、管理、并更使用融资界服务时而提交的基本业务信息（基本资料）和联系人信息，维持业务必要的数据除外。
      </p>
      <p>
        第十一条
        融资界尽可能努力采取各种合理的物理、电子和管理方面的安全措施来保护用户信息。防止用户信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。
      </p>
      <p class="text-right">HONGKONG PROFIT POWER LIMITED</p>
    </div>
    <!-- 域名价值估算声明 -->
    <div v-if="type == 6">
      <h2>域名价值估算声明</h2>
      <p>尊敬的用户：</p>
      <p class="sj">
        融资界应注册用户申请对域名价值进行估算，估算的结果仅供用户进行参考，一经估算，注册用户不得高于融资界估算的价值发布借款。若因为域名行情发生变化，则域名的估算价值可能会被调高或者调低。若用户在估算的价值范围内质押域名发布借款，也仍然存在着不被其他注册用户认可的可能性。
      </p>
      <p class="sj">
        用户点击确认本声明，代表用户同意、认可域名估算结果仅供注册用户进行参考，且融资界不对域名价值估算承担责任，估算价值是否合理，由用户自行判断并承担域名估值可能不准确所带来的风险。
      </p>
      <p>特此声明。</p>
      <p class="text-right">HONGKONG PROFIT POWER LIMITED</p>
    </div>
    <!-- 域名信用周转协议 -->
    <div v-if="type == 7">
      <h2>声明</h2>
      <p>尊敬的用户：</p>
      <p>
        域名投资系注册用户之间的行为，与融资界及其运营公司HONGKONG PROFIT POWER
        LIMITED无关，交易过程由注册用户自行完成。对于域名投资款及域名，融资界及其运营公司HONGKONG
        PROFIT POWER LIMITED没有任何偿还义务，也不承担保证责任和兑付责任。
      </p>
      <p class="text-right">HONGKONG PROFIT POWER LIMITED</p>

      <h2>域名信用周转协议</h2>

      <p>甲方（域名持有人）：</p>
      <div
        v-if="
          agreeData &&
            agreeData.State != 0 &&
            agreeData.State != 3 &&
            agreeData.State != 4 &&
            agreeData.State != 5
        "
      >
        <table>
          <tr>
            <td :style="{ width: '20%' }">用户ID</td>
            <td>{{ personMsg.LoanUser.UserId }}</td>
            <td>真实姓名</td>
            <td>{{ personMsg.LoanUser.RealName }}</td>
          </tr>
          <tr>
            <td :style="{ width: '20%' }">身份证号码</td>
            <td>{{ personMsg.LoanUser.IdCardNumber }}</td>
            <td>注册邮箱</td>
            <td>{{ personMsg.LoanUser.Email }}</td>
          </tr>
        </table>

        <table :style="{ borderTop: 0 }" width="20%">
          <tr>
            <td :style="{ width: '20%' }">质押域名</td>
            <td colspan="3">（&本信用周转借款无质押域名）</td>
          </tr>
        </table>

        <p>乙方（投资人）：</p>
        <table>
          <tr>
            <td>真实姓名</td>
            <td>用户ID</td>
            <td>投资金额(元)</td>
            <td>投资周期(天)</td>
          </tr>
          <tr v-for="(v, i) in personMsg.InvestmentSchemeList" :key="i">
            <td>{{ v.RealName }}</td>
            <td>{{ v.UserId }}</td>
            <td>{{ v.Amount }}</td>
            <td>{{ v.InvestCycleValue }}</td>
          </tr>
        </table>

        <p>
          甲方、乙方均系融资界知识产权服务平台（以下简称融资界）注册用户，甲、乙双方均
          对域名有比较专业的认识，现就域名投资相关事宜达成如下协议。
        </p>
        <p>
          <b>一、借款基本信息</b>
        </p>
        <p>
          1.1甲方作为域名的持有人，将托管域名质押乙方，向乙方进行借款，乙方同意对甲方进行投资。
        </p>
        <table>
          <tr>
            <td>项目编号</td>
            <td>{{ agreeData.Number }}</td>
          </tr>
          <tr>
            <td>借款详细用途</td>
            <td>{{ agreeData.Description }}</td>
          </tr>
          <tr>
            <td>借款本金数额（小写）</td>
            <td>¥{{ agreeData.Amount }}</td>
          </tr>
          <tr>
            <td>借款本金数额（大写）</td>
            <td>{{ agreeData.Amount | upmoney }}</td>
          </tr>
          <tr>
            <td>借款年化利率</td>
            <td>{{ $math.eval(`${agreeData.Rate}*100`) }}%</td>
          </tr>
          <tr>
            <td>域名管理费率（域名持有人支付）</td>
            <td>{{ $math.eval(`${agreeData.ManagementFeeRate}*100`) }}%/月</td>
          </tr>
          <!-- <tr>
            <td>投资管理费率（投资人支付）</td>
            <td>{{$math.eval(`${safe.InvestManagementFeeRate}*100`)}}%/月</td>
          </tr>-->
          <tr>
            <td>月还款额</td>
            <td>详情见还款计划 （固定）</td>
          </tr>
          <tr>
            <td>还款日</td>
            <td>详情见还款计划 （固定）</td>
          </tr>
          <tr>
            <td>借款到期日</td>
            <td>{{ agreeData.EndAt }}</td>
          </tr>
          <tr>
            <td>协议生效日期</td>
            <td>{{ agreeData.ProtocolAt }}</td>
          </tr>
        </table>

        <p>还款计划：</p>
        <table>
          <tr>
            <td>期数</td>
            <td>还款日期</td>
            <td>还款金额</td>
            <td>还款类型</td>
          </tr>
          <tr v-for="(v, i) in personMsg.RepaymentPlanList" :key="i">
            <td>{{ v.Phase }}</td>
            <td>{{ v.RepayAt }}</td>
            <td>¥{{ v.RepayAmount }}</td>
            <td>{{ v.IsEndPhase == true ? "本金+利息" : "利息" }}</td>
          </tr>
        </table>
      </div>
      <div v-else>
        <table>
          <tr>
            <td>用户ID</td>
            <td>（&ID）</td>
            <td>真实姓名</td>
            <td>（&真实姓名）</td>
          </tr>
          <tr>
            <td>身份证号码</td>
            <td>（&甲方身份证号）</td>
            <td>注册邮箱</td>
            <td>（&注册邮箱）</td>
          </tr>
          <tr>
            <td>质押域名</td>
            <td colspan="3">（&本信用周转借款无质押域名）</td>
          </tr>
        </table>

        <p>乙方（投资人）：</p>
        <table>
          <tr>
            <td>真实姓名</td>
            <td>用户ID</td>
            <td>投资金额</td>
            <td>投资周期</td>
          </tr>
          <tr>
            <td>（&真实姓名）</td>
            <td>（&ID）</td>
            <td>（&投标金额）</td>
            <td>（&投标周期）</td>
          </tr>
        </table>

        <p>
          甲方、乙方均系融资界知识产权服务平台（以下简称融资界）注册用户，甲、乙双方均
          对域名有比较专业的认识，现就域名投资相关事宜达成如下协议。
        </p>
        <p>
          <b>一、借款基本信息</b>
        </p>
        <p>1.1甲方向乙方进行借款，乙方同意对甲方进行投资。</p>
        <table>
          <tr>
            <td>项目编号</td>
            <td>（&借款项目编号）</td>
          </tr>
          <tr>
            <td>借款详细用途</td>
            <td>信用周转</td>
          </tr>
          <tr>
            <td>借款本金数额（小写）</td>
            <td>（&融资金额）</td>
          </tr>
          <tr>
            <td>借款本金数额（大写）</td>
            <td>（&融资金额大写）</td>
          </tr>
          <tr>
            <td>借款年化利率</td>
            <td>（&年化）</td>
          </tr>
          <tr>
            <td>管理费</td>
            <td>（&年化）</td>
          </tr>
          <tr>
            <td>月还款额</td>
            <td>详情见还款计划 （固定）</td>
          </tr>
          <tr>
            <td>还款日</td>
            <td>详情见还款计划 （固定）</td>
          </tr>
          <tr>
            <td>借款到期日</td>
            <td>（&借款到期日）</td>
          </tr>
          <tr>
            <td>协议生效日期</td>
            <td>（&放款时间）</td>
          </tr>
        </table>

        <p>还款计划：</p>
        <table>
          <tr>
            <td>期数</td>
            <td>还款日期</td>
            <td>还款金额</td>
            <td>还款类型</td>
          </tr>
          <tr>
            <td>1</td>
            <td>（&还款日期）</td>
            <td>（&还款金额）</td>
            <td>（&利息）</td>
          </tr>
          <tr>
            <td>2</td>
            <td>（&还款日期）</td>
            <td>（&还款金额）</td>
            <td>（&利息+本金）</td>
          </tr>
        </table>
      </div>
      <p>
        <b>二、协议的订立、生效</b>
      </p>
      <p>
        2.1甲、乙双方通过网络点击的方式在线订立《域名信用周转协议》，投资人点击确认《域名信用周转协议》后，合同成立，乙方在平台释放投资款后，合同生效。
      </p>
      <p>
        2.2《域名信用周转协议》在甲方及乙方之间发生法律效力，合同生效后，融资界其他注册用户可以通过直接代甲方偿还乙方投资款的方式取得乙方投资人资格，届时原乙方投资人退出协议，新乙方投资人加入，《域名信用周转协议》在甲方及新乙方投资人之间继续生效。
      </p>
      <p>
        <b>三、域名</b>
      </p>
      <p>
        3.1
        本协议签订时，甲方并未质押域名，本借款为信用借款，甲方借到的款项，仅用于偿还融资界平台借款，不得用于提现，也不得作其他用途。
      </p>
      <p>
        3.2乙方指定第三方域名服务商（简称域名服务商）为甲、乙双方提供域名处置服务。
      </p>
      <p>3.3甲、乙双方授权并确定由融资界负责通知域名服务商提供域名处置服务。</p>
      <p>
        3.4本协议生效后，甲方应当按时向域名服务商支付域名管理费。甲方可以向域名服务商预存域名管理费，域名服务商优先扣除预存的域名管理费。若甲方未按时结清借款或域名管理费，甲方无权要求域名服务商返还域名。
      </p>
      <p>
        <b>四、承诺及保证</b>
      </p>
      <p>
        4.1甲、乙双方承诺融资界及域名服务商对借款不承担任何风险，也不需要对借款承担保证责任、兑付责任，甲、乙双方域名投资权利义务与融资界无关。融资界网页上所有的数据均为注册用户发布，仅供甲、乙双方进行参考，风险由甲、乙双方自行承担。
      </p>
      <p>
        4.2甲、乙双方承诺，对本协议涉及的所有款项包括本金、利息、管理费等项目的数额由各方自行核算，若发生纠纷的，以融资界记录到的数据为准。
      </p>
      <p>4.3甲方承诺按还款计划偿还投资款本金利息及域名管理费。</p>
      <p>
        4.4甲方承诺其在融资界提交的域名是其所有，且对域名有完全的处置权利，域名不存在任何被盗、赃物、权属、担保、使用权纠纷或其他任何影响域名价值金和权利的情形，也不侵犯他人合法权益。
      </p>
      <p>
        4.5甲方承诺按约定用途使用资金，不得使用用户投资款从事任何违法犯罪活动。
      </p>
      <p>
        4.6乙方确认资金来源合法，并为其合法所有，乙方不存赌博、洗钱、掩饰隐瞒犯罪所得、赃款等违法犯罪情形，也不得吸收他人的资金用于投资。
      </p>
      <p>
        <b>五、付款及还款</b>
      </p>
      <p>
        5.1甲方在融资界平台账户收到款，视为甲方收到款，本借款仅用于偿还甲方融资界其他借款。
      </p>
      <p>
        5.2还款时甲方应当向乙方指定银行账户偿还款项，因指定收款账户发生争议的责任由乙方自行承担。
      </p>
      <p>
        5.3甲方应当按照还款计划还款，还款日不受节假日的影响，还款当日24:00时之前必须还款。
      </p>
      <p>
        <b>六、逾期还款</b>
      </p>
      <p>
        6.1若甲方逾期还款，除按还款计划支付利息外，还应当额外按照每日万分之五的标准向乙方支付罚息。
      </p>
      <p>
        6.2若甲方逾期还款，融资界有权通知域名服务商处置甲方在融资界的域名，域名服务商可以自行或者委托第三方通过议价、一口价、打包价、拍卖方式或其他方式处置域名，域名处置所产生的手续费及其他费用由甲方承担，优先在处置域名所得款项中扣除。
      </p>
      <p>
        6.3甲、乙双方知悉域名属于知识产权、无形资产，并了解域名的特殊性，明白处置域名存在的各种风险，因此甲、乙双方认可域名服务商通过议价、一口价、打包价、拍卖方式或其他方式处置域名过程之中的一切行为并认可处置域名的结果，尤其可能出现处置域名所得的资金不足以偿还全部借款借款的情形，甲、乙双方仍然认可并承诺不会因为域名处置而追究融资界、域名服务商的任何责任。
      </p>
      <p>
        <b>七、域名处置资金</b>
      </p>
      <p>7.1域名处置完后：</p>
      <p>
        7.1.1若处置域名所得款项偿还借款后还有剩余资金，则域名服务商应将剩余资金返还给甲方；
      </p>
      <p>
        7.1.2若处置域名所得款项不足以清偿本协议借款，则甲方应当继续承担清偿责任，直至借款还清为止。
      </p>
      <p>7.2域名处置完后，在域名在融资界用于担保多笔借款情况下：</p>
      <p>
        7.2.1若处置域名所得款项可以偿还全部借款后还有剩余资金，则域名服务商应将剩余资金返还给甲方；
      </p>
      <p>
        7.2.2若处置域名所得款项不能偿还完所有借款，则处置域名所得款项应当按照本融资界借款协议约定的到期日的先后清偿借款，同一天到期的借款，按照比例清偿。未足额得到清偿部分借款，甲方应当继续承担还款责任，直至全部借款还清为止。
      </p>
      <p>
        7.3
        域名处置完后，若处置域名所得款项偿还已到期的借款之后还有剩余资金，但甲方在融资界还有其他未到期的借款需要偿还，则甲方同意将剩余资金作为质押托管在域名服务商用于担保未到期的借款的偿还。
      </p>
      <p>
        <b>八、通知与送达</b>
      </p>
      <p>
        8.1协议各方因履行本协议而相互发出或者提供的所有通知、文件、资料，均以本协议所列明及在融资界留下的联系地址、电话、邮箱、微信、QQ等联系方式进行送达，可由采用专人送达、挂号邮递、特快专递或通过融资界发布等方式传送，一方如果变更联系方式，应当书面通知融资界，电子信息或者邮件一经发出即视为送达。
      </p>
      <p>
        <b>九、管辖及法律适用</b>
      </p>
      <p>
        9.1本协议的成立、生效、履行、解释及纠纷解决，适用仲裁机构所在地区法律。
      </p>
      <p>
        9.2若用户和融资界之间发生任何纠纷或争议无法自行解决的，应向深圳仲裁委员会申请仲裁，仲裁流程及规则以申请时的流程及规则为准。
      </p>
    </div>
    <!-- 域名托管协议 -->
    <div v-if="type == 8">
      <h2>域名托管协议</h2>
      <p>甲方：域名持有人（详见域名投资协议甲方）</p>
      <p>乙方：投资人（详见域名投资协议乙方）</p>
      <p>丙方：域名托管人</p>
      <p>
        丙方是第三方知识产权服务机构，现就知识产权托管相关事宜达成如下协议。
      </p>
      <p>
        <b>一、托管域名</b>
      </p>
      <p>
        1、甲方为域名持有人，甲方为了向乙方融资，甲方自愿将域名（详见域名投资协议）质押给乙方。
      </p>
      <p>
        2、乙方指定丙方作为域名托管人，代乙方接收甲方质押的域名，丙方可以使用自己名下的域名账户或指定其他人名下的域名账户用来接收甲方质押的域名。
      </p>
      <p>3、丙方收到甲方质押的域名视为乙方收到甲方质押的域名。</p>
      <p>
        <b>二、服务内容</b>
      </p>
      <p>
        1、丙方作为域名托管人代为保管甲方的质押域名，并为甲、乙双方提供如下域名托管服务：
        <br />（1）代乙方收取、保管质押域名。
        <br />（2）代甲、乙双方push或转移域名。
        <br />（3）若甲方借款发生违约，代甲、乙双方处置域名服务，并支付处置域名的资金。
        <br />（4）其他与域名相关的服务。
      </p>
      <p>
        2、甲、乙双方授权并确定由融资界负责按照甲、乙双方的约定和融资界的规则通知丙方提供域名托管服务。
      </p>
      <p>
        <b>三、服务费用</b>
      </p>
      <p>
        1、甲方应当按时向提供域名托管服务的丙方支付域名管理费，管理费的标准以域名投资协议约定的为准，域名投资协议生效即开始计算管理费。
      </p>
      <p>2、甲方可以向丙方预存管理费，丙方优先扣除预存的管理费。</p>
      <p>3、若甲方未按时结清借款或管理费，甲方无权要求丙方返还质押域名。</p>
      <p>4、域名托管期间由甲方负责续费。</p>
      <p>
        <b>四、免责条款</b>
      </p>
      <p>1、甲、乙双方确认托管的质押域名无任何争议，不会让丙方承担任何责任。</p>
      <p>
        2、甲方应当将域名续费至足够长的时间防止域名到期，若域名在托管期间内到期，由甲方自行承担责任。
      </p>
      <p>
        3、甲、乙双方知悉域名属于知识产权、无形资产，并了解域名的特殊性，明白处置域名存在的各种风险，因此甲、乙双方认可丙方通过议价、一口价、打包价、拍卖方式或其他方式处置域名过程之中的一切行为并认可处置域名的结果，尤其可能出现处置域名所得的资金不足以偿还甲方全部借款的情形，甲乙双方仍然认可并承诺不会因为域名处置而追究融资界、丙方的任何责任。
      </p>
      <p>
        <b>五、通知与送达</b>
      </p>
      <p>
        1、协议各方因履行本协议而相互发出或者提供的所有通知、文件、资料，均以本协议所列明及在融资界留下的联系地址、电话、邮箱、微信、QQ等联系方式进行送达，可由采用专人送达、挂号邮递、特快专递或通过融资界发布等方式传送，一方如果变更联系方式，应当书面通知融资界。电子信息或邮件一经发出，视为送达。
      </p>
      <p>
        <b>六、管辖及法律适用</b>
      </p>
      <p>
        1、本协议的成立、生效、履行、解释及纠纷解决，适用仲裁机构所在地区法律。
      </p>
      <p>
        2、若用户和融资界之间发生任何纠纷或争议无法自行解决的，应向深圳仲裁委员会申请仲裁，仲裁流程及规则以申请时的流程及规则为准。
      </p>
    </div>
  </div>
</template>
<script>
/*
type [int]
1. 风险告知书 融资者
2. 风险告知书 投资者
3. 域名投资协议
4. 用户服务协议
5. 隐私保护协议
6. 域名价值估算声明
7.域名信用周转协议
8.域名托管协议
*/
export default {
  props: ["type", "agreeData", "personMsg"],
  computed: {
    safe() {
      return this.$store.state.user.safe
    },
  },
}
</script>
<style lang="less" scoped>
.text-right {
  text-align: right;
}
.sj {
  text-indent: 2em;
}
h2 {
  font-size: 18px;
  line-height: 30px;
  text-align: center;
}
h3 {
  font-size: 16px;
  line-height: 30px;
}
p {
  font-size: 14px;
  line-height: 30px;
  // margin: 10px 0;
}
table {
  border: solid 1px #ccc;
  width: 100%;
  border-right: 0;
  border-bottom: 0;
  .domain {
    word-break: break-word;
  }
  td {
    border: 1px solid #ccc;
    border-left: 0;
    border-top: 0;
    // padding: 5px 10px;
    padding: 0 10px;
    height: 29px;
    line-height: 29px;
  }
}
</style>
